import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

import type { SalesYear } from '../models/sales-year.type';

import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class SalesYearsService {
  private _apiService = inject(ApiService);

  public fetchSalesYears(): Observable<SalesYear[]> {
    return this._apiService.get(`/v2/sales-years`);
  }
}
